<template>
  <div class="form-group">
    <label class="mar-lt-15">{{$t('upload.dynamicMenu')}}</label>
    <template v-if="location.use_dynamic_menu">
      <div class="col-md-12 px-0">
        <img v-bind:src="location.dynamic_qr_code">
      </div>
      <div class="col-md-12 mb-5 ml-4 px-0 mar-to-15">
        <a class="btn btn-info btn-icon duplicate-prod" :href="this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + location.dynamic_qr_code + '&name=' + location.city + ' ' + location.name + '.png'" target="_blank">{{$t('upload.download')}}</a>
      </div>
      <div class="row">
        <div class="col-md-10 col-sm-5 mar-lt-15">
          <input
            class="form-control"
            ref="clone"
            v-on:focus="$event.target.select()"
            :value="location.dynamic_menu_url"
            readonly />
        </div>
        <div class="col-md-1 col-sm-1">
          <button class="btn btn-icon btn-info duplicate mar-to-3" @click.prevent="copy">
            <img src="/static/img/icons/duplicate.png">
          </button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  export default {
    name: 'display-qr',
    inheritAttrs: false,
    props: {
      location: Object
    },
    data () {
      return {
        apiUrl: ''
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
    },
    methods: {
      copy () {
        this.$refs.clone.focus()
        document.execCommand('copy')
      }
    }
  }
</script>

<style>
  p {
    overflow: hidden;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .ml-4 {
    margin-left: 1.25rem;
  }
  .px-0 {
    padding-left: 0;
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/DisplayQr.vue